import React from "react";
import { Col, Row } from "react-bootstrap";

import TextBlock from "../components/textBlock";

import stylesLayout from "../../../../components/layout/layout.module.scss";

export const terminalOptionsDictionary = {
	cvv: "CVV",
	avs: "AVS",
	multiMerchant: "MultiMerchant",
	tipAdjust: "Tip Adjust",
	serverNumber: "Server #",
	orderNumber: "Order #",
	amex: "AMEX",
	pinDebit: "PIN Debit",
	externalPinPad: "External PIN Pad",
};

type TerminalOptionsViewProps = {
	terminalOptions: { [key: string]: any };
};

const TerminalOptionsView = ({ terminalOptions }: TerminalOptionsViewProps) => {
	const renderFieldName = fieldName => {
		if (fieldName in terminalOptionsDictionary) {
			fieldName = terminalOptionsDictionary[fieldName];
		}
		return fieldName;
	};

	const terminalOptionsKeys = Object.keys(terminalOptions);

	const filteredTerminalOptions = terminalOptionsKeys.filter(function (key) {
		return terminalOptions[key];
	});

	return (
		<>
			<h6
				className={`${stylesLayout.viewSectionTitle} ${stylesLayout.subTitle}`}
			>
				Options
			</h6>
			<Row>
				{filteredTerminalOptions?.map((item, index) => {
					return (
						<Col
							md={4}
							xl={2}
							key={index}
							className="min-width-120"
						>
							<TextBlock
								iconCheck
								value={renderFieldName?.(item)}
								dataAutotest={`${item}${index + 1}`}
							/>
						</Col>
					);
				})}
			</Row>
		</>
	);
};

export default TerminalOptionsView;
